import { render, staticRenderFns } from "./ClassDetail.vue?vue&type=template&id=738fe62b&scoped=true"
import script from "./ClassDetail.vue?vue&type=script&lang=js"
export * from "./ClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassDetail.vue?vue&type=style&index=0&id=738fe62b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738fe62b",
  null
  
)

export default component.exports